import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'concrete-formwork-sydney';
const serviceId = 1
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {
    const metaTags : MetaTagsProps =  {
        title: `Concrete Formwork Sydney | ${BUSINESS_NAME}`,
        description: "Precision formwork solutions for residential, commercial, and industrial builds.",
        keywords: "concrete formwork Sydney, formwork services Sydney, residential formwork, commercial formwork, industrial formwork, reinforced concrete, steelfixing Sydney, concrete pouring, custom formwork solutions, durable concrete structures, Sydney construction services",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Concrete Formwork Sydney',
    description: 'Precision formwork solutions for residential, commercial, and industrial builds.',
    points: [],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
